import { z } from 'zod';

export const ProjectType = z.enum(['PROJECT', 'TAG']);

export type ProjectTypeT = z.infer<typeof ProjectType>;
